import { render, staticRenderFns } from "./task.vue?vue&type=template&id=33688142&scoped=true&lang=pug&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&id=33688142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33688142",
  null
  
)

export default component.exports